import {
  beFiltersGetFilter,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters
} from 'Api/beFiltersApi'
import {
  beRecipientGetGroupById,
  beRecipientGetListOfGroupDetails
} from 'Api/beRecipientApi'
import {
  GROUPS_SEARCH_TYPE_ECONTAINS,
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  SELECT_MAX_ITEMS,
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE
} from 'Constants/index'
import { storeGet } from 'mailup-react-helpers'
import getIntl from '../../../../helpers/intl'
import { segmentationFiltersState } from '../state/page'
import { getAllAvailableFilterTypes } from './../../../../api/beFiltersApi'

export const fetchGroups = async (searchText = '', excludeGroupId) => {
  const trimmedSearchText = searchText.trim()

  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items, TotalItems } = await beRecipientGetListOfGroupDetails(idList, {
    searchType: GROUPS_SEARCH_TYPE_ECONTAINS,
    searchBy: trimmedSearchText,
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: SELECT_MAX_ITEMS
  })

  const ItemList = Items.filter((v) => v.Id !== excludeGroupId)

  return {
    items: ItemList.map(({ Id, Name }) => ({
      value: Id,
      label: `${Id} - ${Name}`
    })),

    totalItems: TotalItems
  }
}

export const getGroupById = async (idGroup) => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beRecipientGetGroupById(idGroup.value || idGroup)

  if (result !== null && result.IdList === idList) {
    return {
      value: result.Id,
      label: `${result.Id} - ${result.Name}`
    }
  }
  return { value: undefined }
}

// FILTERS
export const fetchFiltersCallback =
  ({ set }) =>
  async (searchTerm = '', excludeFilterId) => {
    const idList = storeGet(STORE_KEY_ID_LIST)
    const loginType = storeGet(STORE_KEY_LOGIN_TYPE)

    const hidden =
      loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
        ? false
        : undefined

    const categories = await beFiltersGetListOfCategories({
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false
    })

    const allCategories = [
      {
        Id: 0,
        Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
      },
      ...categories.Items
    ]

    const { Items, TotalItems } = await beFiltersGetListOfFilters(idList, {
      pageSize: SELECT_MAX_ITEMS,
      pageNumber: 1,
      orderBy: 'Id',
      orderDescending: false,
      hidden,
      types: getAllAvailableFilterTypes(),
      search: searchTerm
    })

    const ItemList = Items.filter((v) => v.Id !== excludeFilterId)

    const optionGroups = allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: Items.filter(({ Category }) => Category === Id).map(
          ({ Id }) => Id
        )
      }))
      .filter(({ values }) => values.length > 0)

    set(segmentationFiltersState, (prev) => ({ ...prev, optionGroups }))

    return {
      items: ItemList.map(({ Id, Name, Type, Description }) => ({
        value: Id,
        label: `${Id} - ${Name}`,
        type: Type,
        description: Description,
        name: Name
      })),

      totalItems: TotalItems
    }
  }

export const getFilterById = async (idFilter) => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beFiltersGetFilter(idFilter.value || idFilter)

  if (result !== null && result.IdList === idList) {
    return {
      value: result.Id,
      label: `${result.Id} - ${result.Name}`
    }
  }
  return { value: undefined }
}
